import { getDocs, collection } from "@firebase/firestore";
import { hideLoading, setItemTypesList, showLoading } from "./item-types-list-slice";

export const getItemTypesService = async (dispatch, db, coll) => {
    dispatch(showLoading());
    try {
        await getDocs(collection(db, coll))
        .then((querySnapshot) => {
            const data = querySnapshot.docs
                .map((doc) => ({...doc.data(), id:doc.id}));
            dispatch(setItemTypesList(data));
        });
    } catch(e) {
        console.error("ItemTypesList getItemTypesService error: ", e);
    }
    dispatch(hideLoading());
};